import { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import Loader from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { ProfileContext } from "../../context/ProfileContext";
import { BASE_URL, UPDATE_CENTER } from "../../API";

function ViewDiagnosticCenter() {
  const { headers, getCenters } = useContext(ProfileContext)
  const { state } = useLocation();
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("view");
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: state });


  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.patch(BASE_URL + UPDATE_CENTER, data, { headers });

      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        getCenters();
        navigate("/diagnosis-center-management");
      } else {
        toast.error(response.data.message || "Something went wrong");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || "An error occurred. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />

      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/diagnosis-center-management" }}>Diagnosis Center Management</Breadcrumb.Item>
                  <Breadcrumb.Item active>{viewMode === "view" ? "View" : "Edit"} Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>

              <div className="patient_referral_form">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="comm_inner_sub_heading mb-0">{viewMode === "view" ? "View" : "Edit"} Center Details</h5>
                  <button type="button" className="main-outline-btn" onClick={() => setViewMode(viewMode === "view" ? "edit" : "view")}>
                    {viewMode === "view" ? "Edit" : "Cancel Edit"}
                  </button>
                </div>

                <div className="comm_border_box mt-3">
                  <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Center Name</Form.Label>
                          <Form.Control type="text" placeholder="Enter Center Name" disabled={viewMode === "view"}
                            {...register("center_name", { required: "Please enter center name" })}
                          />
                          {errors.center_name && (<span className="error">{errors.center_name.message}</span>)}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" placeholder="Enter Email" disabled={viewMode === "view"}
                            {...register("email", {
                              required: "Please enter email address",
                              pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Invalid email address", },
                            })}
                          />
                          {errors.email && (<span className="error">{errors.email.message}</span>)}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Contact Number</Form.Label>
                          <Form.Control type="text" placeholder="Enter Contact Number" disabled={viewMode === "view"}
                            {...register("contact_number", { required: "Please enter contact number" })}
                          />
                          {errors.contact_number && (<span className="error">{errors.contact_number.message}</span>)}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Address</Form.Label>
                          <Form.Control type="text" placeholder="Enter Address" disabled={viewMode === "view"}
                            {...register("address", { required: "Please enter address" })} />
                          {errors.address && (<span className="error">{errors.address.message}</span>)}
                        </Form.Group>
                      </Col>

                      {/* <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Recommended By</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Recommender Name"
                            disabled={viewMode === "view"}
                            {...register("recommended_by")}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Available Tests</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Available Tests"
                            disabled={viewMode === "view"}
                            {...register("available_tests")}
                          />
                        </Form.Group>
                      </Col> */}
                    </Row>

                    {viewMode === "edit" && (
                      <div className="modal_pair_btns patient_referral_btns mt-3">
                        <button className="main-btn" type="submit">Submit</button>
                        <button type="button" className="main-outline-btn" onClick={() => navigate("/diagnostic-center-management")}>Discard Changes</button>
                      </div>
                    )}
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewDiagnosticCenter;
